<template>
  <!-- 桶站列表 -->
  <div>
    <div class="container_right_top">
      <el-form :inline="true" :model="queryParam" class="demo-form-inline" size="mini">
        <el-form-item label="街道">
          <el-input
            v-model="queryParam.streetName"
            @keyup.enter.native="searchQuery"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="工作社区">
          <el-input
            v-model="queryParam.communityName"
            @keyup.enter.native="searchQuery"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="桶站号">
          <el-input
            v-model="queryParam.garbageStationNo"
            @keyup.enter.native="searchQuery"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="success" @click="addInfo">添加</el-button>
        </el-form-item>
      </el-form>
    </div>

    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #handlerSlot="slotData">
        <el-button type="primary" size="mini" @click="handleEdit(slotData.data.row)"
          >编辑</el-button
        >
        <el-popconfirm title="确定删除吗？" @confirm="handleDelete(slotData.data.row)">
          <template #reference>
            <el-button
              size="mini"
              type="danger"
              >删除</el-button
            >
          </template>
        </el-popconfirm>
      </template>
    </e-table>

    <el-dialog
      :title="formText"
      :visible.sync="dialogFormVisible"
      :before-close="formClear"
    >
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item
          label="街道"
          :label-width="formLabelWidth"
          prop="streetName"
        >
          <el-select
            v-model="form.streetName"
            placeholder="请选择街道"
            @change="communityChange"
          >
            <el-option
              v-for="item in communityNameArr"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="工作社区"
          :label-width="formLabelWidth"
          prop="communityName"
        >
          <el-select v-model="form.communityName" placeholder="请选择工作社区">
            <el-option
              v-for="item in residentialQuartersArr"
              :key="item.id"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="桶站号"
          :label-width="formLabelWidth"
          prop="garbageStationNo"
        >
          <el-input
            v-model="form.garbageStationNo"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="垃圾桶数量" :label-width="formLabelWidth">
          <el-input v-model="form.garbageCanNum" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="有无备桶" :label-width="formLabelWidth">
          <el-select v-model="form.hasGarbageCanSpare" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <!-- <el-input
            v-model="form.hasGarbageCanSpare"
            autocomplete="off"
          ></el-input> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitHandler('ruleForm')"
          >确 定</el-button
        >
        <el-button @click="formClear">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
import { httpAction, uploadAction } from "@/api/manage";
export default {
  components: { eTable },
  mixins: [listMixin],
  data() {
    return {
      url: {
        list: "/garbageStation/queryGarbageStation",
        addOrEdit: "/garbageStation/saveOrUpdateGarbageStation",
        deleteGarbageStation: "/garbageStation/deleteGarbageStation",
        queryArea: "/address/street/list",
        queryResidentialQuarters: "/address/community/list",
      },
      queryParam: {
        streetName: "",
        communityName: "",
        garbageStationNo: "",
      },
      options: [
        {
          value: "1",
          label: "有",
        },
        {
          value: "2",
          label: "无",
        },
      ],
      columns: [
        { field: "streetName", label: "街道" },
        { field: "communityName", label: "工作社区" },
        { field: "garbageStationNo", label: "桶站号" },
        { field: "garbageCanNum", label: "垃圾桶数量" },
        { field: "hasGarbageCanSpare", label: "有无备桶" },
        {
          width: 200,
          label: "操作",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
      dialogFormVisible: false,
      formLabelWidth: "100px",
      formText: "",
      form: {
        id: null,
        communityId: null,
        garbageStationNo: "",
        streetId: null,
        streetName: "后沙峪镇",
        communityName: "",
        garbageCanNum: "",
        hasGarbageCanSpare: "",
      },
      communityNameArr: [],
      residentialQuartersArr: [],
      rules: {
        garbageStationNo: [
          { required: true, message: "请填写桶站号", trigger: "blur" },
          {
            min: 1,
            max: 12,
            message: "长度在 1 到 12 个字符",
            trigger: "blur",
          },
        ],
        streetName: [
          { required: true, message: "请选择街道", trigger: "change" },
        ],
        communityName: [
          { required: true, message: "请选择工作社区", trigger: "change" },
        ],
      },
    };
  },
  updated() {
    this.dataSource.forEach((item) => {
      if (
        item.hasGarbageCanSpare !== null &&
        item.hasGarbageCanSpare !== "有" &&
        item.hasGarbageCanSpare !== "无"
      ) {
        item.hasGarbageCanSpare = item.hasGarbageCanSpare === 1 ? "有" : "无";
      }
    });
  },
  methods: {
    async addInfo() {
      this.formText = "添加";
      this.dialogFormVisible = true;
      this.form.streetName = "后沙峪镇";
      let { code, data } = await httpAction(this.url.queryArea, {}, "get");
      if (code === 200) {
        this.communityNameArr = data;
      } else {
        this.$message.warning("请求失败,请重新尝试");
      }
      let res = await httpAction(
        this.url.queryResidentialQuarters,
        { wlStreetId: [6] },
        "post"
      );
      this.residentialQuartersArr = res.data;
    },
    async handleEdit(row) {
      if (this.$refs["ruleForm"]) {
        this.$nextTick(() => {
          this.$refs["ruleForm"].clearValidate();
        });
      }
      this.formText = "编辑";
      this.dialogFormVisible = true;
      let { code, data } = await httpAction(this.url.queryArea, {}, "get");
      if (code === 200) {
        this.communityNameArr = data;
      } else {
        this.$message.warning("请求失败,请重新尝试");
      }
      let res = await httpAction(
        this.url.queryResidentialQuarters,
        { wlStreetId: [row.streetId] },
        "post"
      );
      console.log(row);
      console.log(res);
      this.residentialQuartersArr = res.data;
      this.form.streetName = row.streetName;
      this.form.streetId = row.streetId;
      this.form.garbageStationNo = row.garbageStationNo;
      this.form.communityName = row.communityName;
      this.form.communityId = row.communityId;
      this.form.id = row.id;
      this.form.garbageCanNum = row.garbageCanNum;
      this.form.hasGarbageCanSpare = row.hasGarbageCanSpare;
      console.log(this.form);
    },
    formClear() {
      this.dialogFormVisible = false;
      this.communityNameArr = [];
      this.form.garbageStationNo = "";
      this.form.communityName = "";
      this.form.streetName = "";
      this.form.communityId = null;
      this.form.id = null;
      this.form.garbageCanNum = "";
      this.form.hasGarbageCanSpare = "";
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
      });
    },
    async communityChange(val) {
      this.form.communityName = "";
      let { id } = this.communityNameArr.find((item) => item.name === val);
      let { data } = await httpAction(
        this.url.queryResidentialQuarters,
        { wlStreetId: [id] },
        "post"
      );
      this.residentialQuartersArr = data;
    },
    submitHandler(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.formText === "添加") {
            let { id } = this.communityNameArr.find(
              (item) => item.name === this.form.streetName
            );
            this.form.streetId = id;
            let arr = this.residentialQuartersArr.find(
              (item) => item.name === this.form.communityName
            );
            this.form.communityId = arr.id;
          }
          console.log(this.communityNameArr);
          let { id } = this.communityNameArr.find(
            (item) => item.id === this.form.streetId
          );
          this.form.streetId = id;
          console.log(this.form.communityName);
          let arr = this.residentialQuartersArr.find(
            (item) => item.id === this.form.communityId
          );
          this.form.communityId = arr.id;
          if (
            this.form.hasGarbageCanSpare === "有" ||
            this.form.hasGarbageCanSpare === "无"
          )
            this.form.hasGarbageCanSpare =
              this.form.hasGarbageCanSpare === "有" ? 1 : 2;
          let res = await httpAction(
            this.url.addOrEdit,
            { ...this.form },
            "post"
          );
          if (res.code === 200) {
            this.formClear();
            this.loadData(1);
          } else {
            this.$message.warning("请求失败,请重新尝试");
          }
        } else {
          this.$message.error("缺少必填项");
          return false;
        }
      });
    },
    async handleDelete(row) {
      let res = await httpAction(
        this.url.deleteGarbageStation,
        [row.id],
        "post"
      );
      if (res.code === 200) {
        this.loadData(1);
        this.$message.success('删除成功');
      } else {
        this.$message.warning("请求失败,请重新尝试");
      }
    },
    // handleSizeChange(val) {
    //   this.params.pageSize = val
    //   this.getGarbageStation()
    // },
    // handleCurrentChange(val) {
    //   this.params.pageNo = val
    //   this.getGarbageStation()
    // },
  },
  created() {
    // this.loadData(1)
  },
};
</script>

<style scoped lang="less">
/deep/.el-table__cell {
  text-align: center;
}
/deep/.el-pagination {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.container_right_top {
  margin: 10px 0;
}
</style>